module.exports = __webpack_public_path__ + "assets/img/solutions3.79086d62.png";